// @flow strict

import * as React from 'react';
import BlockWrapper from '../BlockWrapper';
import BoardCta from '../BoardCta';
import DealsCta from '../DealsCta';
import TenderCta from '../TenderCta';
import TrilineGRCCta from '../TriLineGRCCta';
import TvCta from '../TvCta';
import WorkflowCta from '../WorkflowCta';
import SecureShareCta from '../SecureShareCta';
import ESGCta from '../ESGCta';
import AlwaysCta from '../AlwaysCta';

type CtaLink = {|
  text: string,
  href: string,
|};

type BackgroundColors = 'White' | 'Silver' | 'Charcoal' | 'Green' | 'Black';
type Feature =
  | 'Board'
  | 'Deals'
  | 'TrilineGRC'
  | 'Tenders'
  | 'Tv'
  | 'Workflow'
  | 'SecureShare'
  | 'Always'
  | 'ESG';

type Block = {|
  background?: BackgroundColors,
  feature?: Feature,
  text?: string,
  ctaLinks: Array<CtaLink>,
  theme?: 'Light' | 'Dark',
|};

type PropTypes = {|
  blocks: Array<Block>,
|};

const FeaturesCta = ({ blocks }: PropTypes) => (
  <BlockWrapper>
    {blocks.map(block => (
      <Item {...block} />
    ))}
  </BlockWrapper>
);

const findBestTheme = (background?: BackgroundColors) => {
  switch (background) {
    case 'Black':
      return 'Light';
    default: {
      return 'Dark';
    }
  }
};

const Item = ({ background = 'Silver', feature, text, ctaLinks }: Block) => {
  const ctaProps = { background, text, theme: findBestTheme(background), ctaLinks };
  switch (feature) {
    case 'TrilineGRC':
      return <TrilineGRCCta {...ctaProps} />;
    case 'Deals':
      return <DealsCta {...ctaProps} />;
    case 'Tenders':
      return <TenderCta {...ctaProps} />;
    case 'Tv':
      return <TvCta {...ctaProps} />;
    case 'Workflow':
      return <WorkflowCta {...ctaProps} />;
    case 'SecureShare':
      return <SecureShareCta {...ctaProps} />;
    case 'ESG':
      return <ESGCta {...ctaProps} />;
    case 'Always':
      return <AlwaysCta {...ctaProps} />;
    default:
      return <BoardCta {...ctaProps} />;
  }
};

export default FeaturesCta;
